import * as angular from "angular";
import { ApiUserService } from "../../services/user.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let ChangePasswordDialog = {
    selector: "vcChangePasswordDialog",
    templateUrl: "/angular/components/profile/change-password.component.html",
    bindings: {
        user: "=",
    },
    controller: class ChangePasswordDialogController {
        // * bindings for typescript compiler *
        public user: any;
        // ************************************

        public viewPassword = false;
        public passwordError: string | null = null;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private apiUserService: ApiUserService;

        constructor(
            ApiUserService: ApiUserService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.apiUserService = ApiUserService;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        confirm(): void {
            this.passwordError = null;
            if (this.user.newpassword != this.user.confirmpassword) {
                this.passwordError = "Your two password fields do not match";
            } else if (this.user.newpassword == this.user.currentpassword) {
                this.passwordError =
                    "Your new password is the same as your current password";
            } else {
                this.apiUserService
                    .updatePassword(this.user)
                    .then((response: object) => {
                        let json = response["data"];
                        if (json.success == false) {
                            this.passwordError = json.message;
                        } else {
                            this.toast.success("New password saved");
                            this.user.newpassword =
                                this.user.confirmpassword =
                                this.user.currentpassword =
                                    null;
                            this.dialog.hide(this.user);
                        }
                    });
            }
        }
    },
};

angular
    .module("profile")
    .component(ChangePasswordDialog.selector, ChangePasswordDialog);
